import { render, staticRenderFns } from "./EditorMobileHeader.vue?vue&type=template&id=025742c8&"
import script from "./EditorMobileHeader.vue?vue&type=script&lang=ts&"
export * from "./EditorMobileHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EditorMobileHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports